<script setup lang="ts">
import { computed } from 'vue';

import { getCssCustomPropertyValue, getStringStyles } from '@libs/ui';

import { useGlobalCurrencyStore } from '../../../stores/globalCurrencyStore';

import { getPlusMinusMark } from './MoneyFormatter.helper';
import type { MoneyFormatterData } from './MoneyFormatter.model';

interface MoneyFormatterProps {
  data: MoneyFormatterData;
}

const props = defineProps<MoneyFormatterProps>();

const globalCurrencyStore = useGlobalCurrencyStore();

const style = computed(() =>
  getStringStyles(props.data.color, getCssCustomPropertyValue)
);

const price = computed(() =>
  globalCurrencyStore.formatMoney(
    Math.abs(props.data.price),
    props.data.currency
  )
);

const formatedLabel = computed(
  () =>
    `${props.data.minPrice !== undefined ? `${props.data.minPrice} - ` : ''}${
      props.data.showPlusMinusMark
        ? `${getPlusMinusMark(props.data.price)} `
        : ''
    }${price.value}`
);
</script>

<template>
  <span :style="style" :class="[props.data.font]">
    {{ formatedLabel }}
  </span>
</template>
